import React from 'react'

const AdminStatements = () => {
  const dummyData = [
    {
      slNo: 1,
      date: "2025-01-15",
      documentId: "DOC12345",
      serviceDescription: "Revenue 1",
      invoiceAmount: 500,
      debitAmount: 100,
      creditAmount: 200,
      totalAmount: 600,
    },
    {
      slNo: 2,
      date: "2025-01-16",
      documentId: "DOC12346",
      serviceDescription: "Revenue 2",
      invoiceAmount: 700,
      debitAmount: 300,
      creditAmount: 100,
      totalAmount: 1100,
    },
    {
      slNo: 3,
      date: "2025-01-17",
      documentId: "DOC12347",
      serviceDescription: "Banner Amount",
      invoiceAmount: 400,
      debitAmount: 200,
      creditAmount: 150,
      totalAmount: 550,
    },
    {
      slNo: 4,
      date: "2025-01-18",
      documentId: "DOC12348",
      serviceDescription: "Offer Amount",
      invoiceAmount: 600,
      debitAmount: 100,
      creditAmount: 300,
      totalAmount: 800,
    },
    {
      slNo: 5,
      date: "2025-01-19",
      documentId: "DOC12349",
      serviceDescription: "Sponsor Amount",
      invoiceAmount: 900,
      debitAmount: 400,
      creditAmount: 250,
      totalAmount: 1150,
    },
    {
      slNo: 6,
      date: "2025-01-20",
      documentId: "DOC12350",
      serviceDescription: "Revenue 3",
      invoiceAmount: 550,
      debitAmount: 200,
      creditAmount: 100,
      totalAmount: 650,
    },
    {
      slNo: 7,
      date: "2025-01-21",
      documentId: "DOC12351",
      serviceDescription: "Revenue 4",
      invoiceAmount: 750,
      debitAmount: 300,
      creditAmount: 200,
      totalAmount: 1250,
    },
    {
      slNo: 8,
      date: "2025-01-22",
      documentId: "DOC12352",
      serviceDescription: "Ad Fee",
      invoiceAmount: 800,
      debitAmount: 400,
      creditAmount: 300,
      totalAmount: 1100,
    },
    {
      slNo: 9,
      date: "2025-01-23",
      documentId: "DOC12353",
      serviceDescription: "Service Fee",
      invoiceAmount: 650,
      debitAmount: 250,
      creditAmount: 150,
      totalAmount: 750,
    },
    {
      slNo: 10,
      date: "2025-01-24",
      documentId: "DOC12354",
      serviceDescription: "Revenue 5",
      invoiceAmount: 900,
      debitAmount: 350,
      creditAmount: 300,
      totalAmount: 1200,
    },
    {
      slNo: 11,
      date: "2025-01-25",
      documentId: "DOC12355",
      serviceDescription: "Sponsor Fee",
      invoiceAmount: 500,
      debitAmount: 200,
      creditAmount: 100,
      totalAmount: 600,
    },
    {
      slNo: 12,
      date: "2025-01-26",
      documentId: "DOC12356",
      serviceDescription: "Offer Amount",
      invoiceAmount: 700,
      debitAmount: 250,
      creditAmount: 200,
      totalAmount: 950,
    },
    {
      slNo: 13,
      date: "2025-01-27",
      documentId: "DOC12357",
      serviceDescription: "Banner Fee",
      invoiceAmount: 800,
      debitAmount: 400,
      creditAmount: 250,
      totalAmount: 1050,
    },
    {
      slNo: 14,
      date: "2025-01-28",
      documentId: "DOC12358",
      serviceDescription: "Service Fee",
      invoiceAmount: 650,
      debitAmount: 300,
      creditAmount: 150,
      totalAmount: 800,
    },
    {
      slNo: 15,
      date: "2025-01-29",
      documentId: "DOC12359",
      serviceDescription: "Revenue 6",
      invoiceAmount: 900,
      debitAmount: 350,
      creditAmount: 250,
      totalAmount: 1200,
    },
    {
      slNo: 16,
      date: "2025-01-30",
      documentId: "DOC12360",
      serviceDescription: "Ad Fee",
      invoiceAmount: 500,
      debitAmount: 100,
      creditAmount: 200,
      totalAmount: 600,
    },
    {
      slNo: 17,
      date: "2025-01-31",
      documentId: "DOC12361",
      serviceDescription: "Service Fee",
      invoiceAmount: 750,
      debitAmount: 300,
      creditAmount: 250,
      totalAmount: 1100,
    },
    {
      slNo: 18,
      date: "2025-02-01",
      documentId: "DOC12362",
      serviceDescription: "Offer Amount",
      invoiceAmount: 800,
      debitAmount: 400,
      creditAmount: 300,
      totalAmount: 1100,
    },
    {
      slNo: 19,
      date: "2025-02-02",
      documentId: "DOC12363",
      serviceDescription: "Sponsor Amount",
      invoiceAmount: 700,
      debitAmount: 250,
      creditAmount: 150,
      totalAmount: 850,
    },
    {
      slNo: 20,
      date: "2025-02-03",
      documentId: "DOC12364",
      serviceDescription: "Revenue 7",
      invoiceAmount: 550,
      debitAmount: 200,
      creditAmount: 100,
      totalAmount: 650,
    },
  ];
  return (
    <div className="h-full w-full">
      {/* Fixed header */}
      <div className="relative w-full bg-white">
        <div className="">
          <div className="flex flex-col space-y-4 border-b bg-white pb-5">
            <div className="flex gap-4">
              <div className="flex flex-col gap-2">
                <label htmlFor="startDate" className="font-medium">
                  Start Date
                </label>
                <input
                  id="startDate"
                  type="date"
                  className="px-3 py-1 border border-black rounded-md"
                />
              </div>
              <div className="flex flex-col gap-2">
                <label htmlFor="endDate" className="font-medium">
                  End Date
                </label>
                <input
                  id="endDate"
                  type="date"
                  className="px-3 py-1 border border-black rounded-md"
                />
              </div>
            </div>
            <button className="border py-1 w-44">Search</button>
          </div>

          {/* Header */}
          <div className="grid  grid-cols-[4rem,2fr,2fr,2.5fr,2.5fr,2.5fr,2.5fr,2fr] bg-white p-2 font-medium text-brand-button-green-bg">
            <div className="text-center">Sl No</div>
            <div className="text-center">Date</div>
            <div className="text-center">Document ID</div>
            <div className="text-center">Service Description</div>
            <div className="text-center">Invoice Amount</div>
            <div className="text-center">Debit Amount</div>
            <div className="text-center">Credit Amount</div>
            <div className="text-center">Total Amount</div>
          </div>
        </div>
      </div>

      {/* Content below the header */}
      <div className="">
        {dummyData.map((item, index) => (
          <div
            key={index}
            className="grid grid-cols-[4rem,2fr,2fr,2.5fr,2.5fr,2.5fr,2.5fr,2fr] items-center gap-2 p-2"
          >
            <div className="rounded border p-2 text-center">{item.slNo}</div>
            <div className="rounded border p-2 text-center">{item.date}</div>
            <div className="rounded border p-2 text-center">
              {item.documentId}
            </div>
            <div className="rounded border p-2 text-center">
              {item.serviceDescription}
            </div>
            <div className="rounded border p-2 text-center">
              {item.invoiceAmount}
            </div>
            <div className="rounded border p-2 text-center">
              {item.debitAmount}
            </div>
            <div className="rounded border p-2 text-center">
              {item.creditAmount}
            </div>
            <div className="rounded border p-2 text-center">
              {item.totalAmount}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default AdminStatements